module.exports = __webpack_public_path__ + "static/img/COC2021-3.0a8acfd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-3.jpg
// module id = EBLV
// module chunks = 0